const RouterMapping = [
    { route: "/", predecessors: ["/", "/details"]},
    { route: "/details", predecessors: ["/"]},
    { route: "/error", predecessors: ["/", "/details", "/closed", "/error"]},
    { route: "/closed", predecessors: ["/", "/kiosk"]},
    { route: "/kiosk", predecessors: ["/"]}
]

export default RouterMapping;